import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const VerticalLineShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 504",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 0h22v504H0z"
    })
  });
};

export { VerticalLineShape };
//# sourceMappingURL=VerticalLineShape.js.map
